import { useCallback } from 'react';

import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { ApprovalDecision } from '@this+that/models';
import log from 'loglevel';

const RESPOND_TO_FLOW_APPROVAL = gql`
  mutation respondToFlowApproval(
    $executionId: ID!
    $decision: ApprovalDecision!
    $inboxEntryId: ID
  ) {
    respondToFlowApproval(
      executionId: $executionId
      decision: $decision
      inboxEntryId: $inboxEntryId
    ) {
      executionId
      status
    }
  }
`;

interface RespondToFlowApprovalData {
  respondToFlowApproval: {
    executionId: string;
    status: string;
  };
}

export function useRespondToFlowApproval() {
  const [mutate, { loading }] = useMutation<RespondToFlowApprovalData>(
    RESPOND_TO_FLOW_APPROVAL,
    { refetchQueries: ['getAgentExecutionHistory'] },
  );

  const respondToFlowApproval = useCallback(
    async (
      executionId: string,
      decision: ApprovalDecision,
      inboxEntryId?: string,
    ) => {
      try {
        const { data } = await mutate({
          variables: { executionId, decision, inboxEntryId },
        });
        return data?.respondToFlowApproval ?? null;
      } catch (error) {
        log.error('respondToFlowApproval failed', {
          executionId,
          decision,
          inboxEntryId,
          error,
        });
        throw error;
      }
    },
    [mutate],
  );

  return { respondToFlowApproval, loading };
}
